module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/serejkakovalev-bkg-957021dbb0c3d6de5d39c65357b92919.jpg";